import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markAllNotificationsAsRead } from "../../apis";
import { useAuth } from "../auth";

export function useMarkAllNotificationsAsRead() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { mutate, error, status, data } = useMutation({
    mutationFn: () => {
      const token = user?.accessToken || "";
      return markAllNotificationsAsRead(token);
    },
    onSuccess: () => {
      // Invalidate all notification queries to trigger refetch
      // This is more efficient than resetQueries as it preserves existing data
      // until the refetch completes, providing a better UX
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
        exact: false,
      });
    },
  });

  return {
    markAllAsRead: mutate,
    error,
    status,
    data,
    isPending: status === "pending",
  };
}
